// #region CONSTANTS
export const DEFAULT_BUYING_CYCLE_ID = "3X7FCQ65M";

export const BUYING_INTEL_PAGE_TYPES = Object.freeze({
    BUYING_CYCLES: "buyingCycles",
    ADD: "add",
    OVERVIEW: "overview",
    BUY_PLAN: "buyPlan"
});

export const EMPTY_BUYING_INTEL_FORM_OPTIONS = Object.freeze({
    labelBrands: [],
    seasons: [],
    storeScopes: [],
    currencies: []
});
// #endregion
